import { useState, useEffect } from 'react';

function computeIsDark() {
  return (
    localStorage.getItem('theme') === 'dark' ||
    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
  );
}

// Mirrors the inline theme script in public/index.html and the toggle in AppLayout,
// so pages outside AppLayout (Landing, Login) can pick theme-correct assets.
export default function useIsDarkMode() {
  const [isDark, setIsDark] = useState(computeIsDark);

  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver(() => setIsDark(html.classList.contains('dark')));
    observer.observe(html, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
